module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "banner-settings-icon.8ea3b2b4.svg";